var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"destination-item-plug"},[_c('div',{staticClass:"destination-item-plug__message"},[_vm._v("\n\t\t"+_vm._s(_vm.$t("destination-item.deals-coming-soon"))+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }